/* eslint-disable import/prefer-default-export */
import Vue from 'vue';

const Notification = new Vue();

export { Notification };
